import axios from 'axios';

const getStrapiCollectionData = async (collectionType, modalID) => {
  try {
    const URL = `${window.origin}/online-acquisition-cms/api/${collectionType}?populate=deep&filters[modalID][$eq]=${modalID}`;
    const { data: cmsData } = await axios.get(URL);
    return cmsData.data[0];
  } catch (error) {
    console.error('error', error);
  }
};

export default getStrapiCollectionData;
